const created_at = window.timestamp;
const env = window.environment;

const identify = (values) => {
  const identity = Object.assign({}, values, {
    created_at,
    env,
  });

  _cio.identify(identity);

  console.log('Customer.io identification:', JSON.stringify(identity));
};

export { identify };
